import React from "react";
import { withTranslation } from "react-i18next";
import PropTypes from "prop-types";
import { DivBackgroundOpacity } from "@utils/extra-style";
import {
  countryflagIcons as flagIcons,
  defaultCountryFlag,
} from "@utils/country-data";

// Rule 6: flag for the parameter's country, with a translated tooltip.
// A dash is displayed instead when the parameter applies to all countries.
const Country = (props) => {
  const { t, data } = props;

  return (
    <DivBackgroundOpacity opacity={data.status ? "1" : "0.2"}>
      {data.country ? (
        <img
          src={flagIcons[data.country.id] || defaultCountryFlag}
          alt={t(data.country.name)}
          title={t(data.country.name)}
          className="general-parameters-list__flag-icon"
        />
      ) : (
        <span>-</span>
      )}
    </DivBackgroundOpacity>
  );
};

Country.propTypes = {
  t: PropTypes.func.isRequired,
  data: PropTypes.shape({
    country: PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
    status: PropTypes.bool,
  }),
};

Country.defaultProps = {
  data: { country: null, status: true },
};

export default withTranslation()(Country);
